import { Component, OnDestroy, OnInit } from '@angular/core';
import { AlliancesService } from '@core/services/alliances.service';
import { AnalyticsService } from '@core/services/analytics.service';
import { Store } from '@ngrx/store';
import { UrlService } from '@services/url.service';
import { IHotelsAppState } from '@store/index';
import { ResultsBaseComponent } from './../base/results-base.component';

@Component({
  selector: 'am-app-results-mobile',
  styleUrls: ['./results-mobile.component.scss'],
  templateUrl: './results-mobile.component.html',
})
export class ResultsMobileComponent extends ResultsBaseComponent implements OnInit, OnDestroy {
  constructor(
    protected store$: Store<IHotelsAppState>,
    protected allianceService: AlliancesService,
    protected analyticsService: AnalyticsService,
    protected urlService: UrlService,
  ) {
    super(store$, allianceService, analyticsService, urlService);
  }

  public toggleShowFilters() {
    this.showFilters = !this.showFilters;
    window.scrollTo(0, 0);
  }
}
